import { NotificationRepository } from "../repositories/NotificationDataSourceRepository";

export class DeleteNotification {
	constructor(private repository: NotificationRepository) {}
	execute(params: DeleteNotificationParams): Promise<void> {
		return this.repository.deleteNotification(params.notification_id);
	}
}

export class DeleteNotificationParams {
	constructor(public notification_id: string) {}
}
